import React, { useState, useEffect, useRef } from 'react';
import { firestore } from './firebase';
import MessageList from './MessageList';
import MessageInput from './MessageInput';
import { onSnapshot, addDoc, Timestamp, collection, query} from "firebase/firestore";
import './App.css'; // Import the CSS file for styling


function ChatApp() {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const messagesEndRef = useRef(null); // Ref for auto-scrolling

  // Function to scroll to the bottom of the messages list
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    setLoading(true);
    //get messages and push to list
    const q = query(collection(firestore, "mainChat"));
    const unsubscribe = onSnapshot(q,(querySnapshot) => {
      const msgList = [];
      querySnapshot.forEach((doc) => {
        msgList.push(doc.data());
      });

      console.log(msgList);
      if (msgList) {
        //sort messages
        const sortedList = msgList.sort((a,b) => new Date (a.timestamp.seconds) - new Date(b.timestamp.seconds));

        //map sorted list to key / value array
        const messagesArray = Object.entries(sortedList).map(([key, value]) => ({
          id: key,
          ...value,
        }));

        //get last messages
        const lastMessagesCount = 10;
        //show last
        setMessages(messagesArray.slice(-lastMessagesCount));
        setLoading(false);
      } else {
        setMessages([]);
      }
    });
    return () => unsubscribe(); // Cleanup listener
  }, []);

  // Scroll to bottom whenever messages array updates, but only after initial load
  useEffect(() => {
    if (!loading) {
      scrollToBottom();
    }
  }, [messages, loading]);

  return (
    <div className="chat-app">
      <h1>Asteroid time chat</h1>

       {loading && <p className="loading-indicator">Loading cosmic messages...</p>}

      <div className="messages-display-area">
        <MessageList messages={messages} messagesEndRef={messagesEndRef} />
      </div>
      <MessageInput onSendMessage={sendMessage} />
    </div>

  );

  async function sendMessage(newMessage) {
    console.log(newMessage)
    // Add a new document in collection "mainChat"
    await addDoc(collection(firestore, "mainChat"), {
    type: "chat_message",
    name: newMessage.user,
    text: newMessage.content,
    timestamp: Timestamp.now()
    });
  };
}
export default ChatApp;


/**
const messagesArray = Object.entries(messagesData).map(([key, value]) => ({
          id: key,
          ...value,
        }));

**/